import React, { useState } from 'react';
import { Button } from './ui/Button';
export function PartnerForm() {
  const [status, setStatus] = useState<'idle' | 'submitting' | 'success' | 'error'>('idle');
  return <section id="partner" className="py-24 bg-gray-50 border-t border-gray-100" data-id="element-109">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-110">
        <div className="text-center mb-12" data-id="element-111">
          <h2 className="text-3xl md:text-4xl font-bold text-[#1a1a1a] mb-4" data-id="element-112">
            Partner With Us
          </h2>
          <p className="text-xl text-gray-700" data-id="element-113">
            This work is only possible because of our community partners who
            serve as judges and sponsors. Please fill out the form below to join
            us.
          </p>
        </div>

        {status === 'success' ? <div className="bg-[#4A6FA5]/5 p-8 rounded-lg text-center border border-[#4A6FA5]/20" data-id="element-114">
            <h3 className="text-2xl font-bold text-[#4A6FA5] mb-4" data-id="element-115">
              Thank you for your interest.
            </h3>
            <p className="text-gray-700 mb-6" data-id="element-116">
              We have received your inquiry and will be in touch shortly to
              discuss how we can work together.
            </p>
            <Button variant="outline" onClick={() => setStatus('idle')} data-id="element-117">
              Send Another Message
            </Button>
          </div> : status === 'error' ? <div className="bg-red-50 p-8 rounded-lg text-center border border-red-200" data-id="element-118">
            <h3 className="text-2xl font-bold text-red-700 mb-4" data-id="element-119">
              Something went wrong
            </h3>
            <p className="text-gray-700 mb-6" data-id="element-120">
              We couldn't send your message. Please try again or email us
              directly at{' '}
              <a href="mailto:info@goodfatherproject.org" className="text-[#4A6FA5] hover:underline" data-id="element-121">
                info@goodfatherproject.org
              </a>
            </p>
            <Button variant="outline" onClick={() => setStatus('idle')} data-id="element-122">
              Try Again
            </Button>
          </div> : <form action="https://formsubmit.co/travishellstrom@gmail.com" method="POST" className="space-y-6 bg-white p-8 md:p-12 rounded-lg border border-gray-200 shadow-sm" data-id="element-123">
            {/* FormSubmit configuration */}
            <input type="hidden" name="_subject" value="New Partnership Inquiry - Good Father Project" data-id="element-124" />
            <input type="hidden" name="_captcha" value="false" data-id="element-125" />
            <input type="hidden" name="_template" value="table" data-id="element-126" />

            <div className="grid md:grid-cols-2 gap-6" data-id="element-127">
              <div className="space-y-2" data-id="element-128">
                <label htmlFor="orgName" className="block text-sm font-medium text-[#1a1a1a]" data-id="element-129">
                  Organization Name
                </label>
                <input type="text" id="orgName" name="Organization" required className="w-full px-4 py-3 bg-white border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#4A6FA5] focus:border-transparent outline-none transition-all" placeholder="Local organization" data-id="element-130" />
              </div>

              <div className="space-y-2" data-id="element-131">
                <label htmlFor="contactName" className="block text-sm font-medium text-[#1a1a1a]" data-id="element-132">
                  Contact Name
                </label>
                <input type="text" id="contactName" name="Name" required className="w-full px-4 py-3 bg-white border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#4A6FA5] focus:border-transparent outline-none transition-all" placeholder="Your full name" data-id="element-133" />
              </div>
            </div>

            <div className="space-y-2" data-id="element-134">
              <label htmlFor="email" className="block text-sm font-medium text-[#1a1a1a]" data-id="element-135">
                Email Address
              </label>
              <input type="email" id="email" name="Email" required className="w-full px-4 py-3 bg-white border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#4A6FA5] focus:border-transparent outline-none transition-all" placeholder="name@organization.org" data-id="element-136" />
            </div>

            <div className="space-y-2" data-id="element-137">
              <label htmlFor="message" className="block text-sm font-medium text-[#1a1a1a]" data-id="element-138">
                Message
              </label>
              <textarea id="message" name="Message" required rows={4} className="w-full px-4 py-3 bg-white border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#4A6FA5] focus:border-transparent outline-none transition-all resize-none" placeholder="Tell us how you'd like to partner..." data-id="element-139" />
            </div>

            <div className="pt-4" data-id="element-140">
              <Button type="submit" className="w-full md:w-auto" data-id="element-141">
                Send
              </Button>
            </div>
          </form>}
      </div>
    </section>;
}